<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <form>
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>{{ formIcon }}</md-icon>
            </div>
            <h4 v-if="!requesting" class="title">
              Dienst "{{ shift.name }}" perioden
            </h4>
          </md-card-header>
          <md-card-content>
            <time-line plain type="simple">
              <time-line-item-shift-period
                inverted
                badge-type="primary"
                badge-icon="schedule"
                v-for="(period, index) in this.dataShiftPeriods"
                :key="index"
                v-model="shiftPeriods[index]"
                :data="period"
                :routes="routes"
              ></time-line-item-shift-period>
            </time-line>
          </md-card-content>

          <md-card-actions>
            <md-button
              native-type="button"
              @click.native.prevent="goBack"
              v-bind:class="{
                'md-primary': !formTouched,
                'md-warning': formTouched
              }"
              :disabled="requesting"
              >Terug</md-button
            >
            <md-button
              native-type="button"
              @click.native.prevent="handleAddPeriod(shiftId())"
              class="md-success"
              :disabled="requesting"
              >Dienst periode toevoegen
            </md-button>
          </md-card-actions>
        </md-card>
      </form>
    </div>
    <div class="md-layout-item md-size-100">
      <md-card class="md-card-calendar">
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>{{ formIcon2 }}</md-icon>
          </div>
          <h4 v-if="!requesting" class="title">
            Voorbeeld dienst "{{ shift.name }}" van actieve dagen
          </h4>
        </md-card-header>
        <md-card-content v-if="showEvents">
          <fullCalendar
            locale="nl"
            :button-text="{ today: 'Huidige week' }"
            ref="calendar"
            defaultView="listWeek"
            :valid-range="calendarValidRange"
            :plugins="calendarPlugins"
            :events="getEvents"
            :first-day="1"
            :header="header"
            :buttonIcons="buttonIcons"
            height="auto"
            allDayText="Gehele dag"
          />
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import { TimeLine, TimeLineItemShiftPeriod } from "@/components";
import FullCalendar from "@fullcalendar/vue";
import listPlugin from "@fullcalendar/list";
import ShiftsMethods from "./ShiftsMethods.js";
import RoutesMethods from "../Routes/RoutesMethods";

var today = new Date();
var y = today.getFullYear();
var m = today.getMonth();
var d = today.getDate();

export default {
  components: {
    TimeLine,
    TimeLineItemShiftPeriod,
    FullCalendar
  },
  data() {
    return {
      responsive: false,
      requesting: false,
      shift: {},
      shiftPeriods: [],
      routes: [],
      selectedRoutes: {},
      routesPeriods: [],
      holidays: [],
      calendarPlugins: [listPlugin],
      header: {
        left: "",
        center: "title",
        right: "today,prev,next"
      },
      buttonIcons: {
        close: "fa-times",
        prev: "left-single-arrow",
        next: "right-single-arrow",
        prevYear: "fa-angle-double-left",
        nextYear: "fa-angle-double-right"
      }
    };
  },
  computed: {
    formIcon: function() {
      if (this.requesting) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "departure_board";
      }
      return "departure_board";
    },
    formIcon2: function() {
      if (this.requesting || !this.showEvents) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "departure_board";
      }
      return "departure_board";
    },
    simpleTimeline() {
      if (this.responsive) {
        return "simple";
      }
      return "simple";
    },
    formTouched: function() {
      return false;
    },
    dataShiftPeriods: function() {
      var periods = [];

      if (this.shiftPeriods === undefined) {
        return periods;
      }

      for (var i in this.shiftPeriods) {
        if (this.shiftPeriods[i].id.length !== 36) {
          continue;
        }

        periods.push(this.shiftPeriods[i]);
      }

      return periods;
    },
    dataRoutePeriods: function() {
      let periods = [];

      for (let index in this.routesPeriods) {
        periods[index] = [];
        if (this.routesPeriods[index] === undefined) {
          continue;
        }

        for (var i in this.routesPeriods[index]) {
          if (this.routesPeriods[index][i].id.length !== 36) {
            continue;
          }

          periods[index].push(this.routesPeriods[index][i]);
        }
      }

      return periods;
    },
    calendarValidRange: function() {
      return {
        start: this.calanderGetStartDate,
        end: this.calanderGetStopDate
      };
    },
    calanderGetStartDate: function() {
      var startDate = new Date(today);
      startDate.setUTCDate(startDate.getUTCDate() - 40);
      return ShiftsMethods.formatDate(
        startDate.getUTCFullYear() +
          "-" +
          (startDate.getUTCMonth() + 1) +
          "-" +
          startDate.getUTCDate()
      );
    },
    calanderGetStopDate: function() {
      var stopDate = new Date(today);
      stopDate.setUTCDate(stopDate.getUTCDate() + 180);
      return ShiftsMethods.formatDate(
        stopDate.getUTCFullYear() +
          "-" +
          (stopDate.getUTCMonth() + 1) +
          "-" +
          stopDate.getUTCDate()
      );
    },
    calendarGetDateRangeArray: function() {
      var dates = [];
      var startDate = this.calanderGetStartDate;
      var stopDate = this.calanderGetStopDate;

      var date = new Date(startDate);
      dates.push(startDate);

      while (
        stopDate >
        ShiftsMethods.formatDate(
          date.getUTCFullYear() +
            "-" +
            (date.getUTCMonth() + 1) +
            "-" +
            date.getUTCDate()
        )
      ) {
        date.setUTCDate(date.getUTCDate() + 1);
        dates.push(
          ShiftsMethods.formatDate(
            date.getUTCFullYear() +
              "-" +
              (date.getUTCMonth() + 1) +
              "-" +
              date.getUTCDate()
          )
        );
      }

      return dates;
    },
    getEvents: function() {
      if (this.routesPeriods.length === 0) {
        return [];
      }

      var events = [];
      var dates = this.calendarGetDateRangeArray;

      for (var i in dates) {
        if (this.isDateHoliday(dates[i])) {
          events.push({
            title: this.getHolidayNameByDate(dates[i]),
            start: new Date(dates[i] + " 00:00:00"),
            end: new Date(dates[i] + " 23:59:59"),
            backgroundColor: "red",
            className: "event-red",
            allDay: false
          });

          continue;
        }

        for (let routeIndex in this.selectedRoutes) {
          var dayShiftStatus = ShiftsMethods.getperiodDayStatusByDate(
            dates[i],
            ShiftsMethods.getperiodByDate(
              dates[i],
              this.dataShiftPeriods,
              this.routes[routeIndex]["id"]
            )
          );
          var dayRouteStatus =
            this.dataRoutePeriods.length === 0
              ? 0
              : RoutesMethods.getperiodDayStatusByDate(
                  dates[i],
                  RoutesMethods.getperiodByDate(
                    dates[i],
                    this.dataRoutePeriods[routeIndex]
                  )
                );

          var startStopTimes = [];
          if (dayShiftStatus === 1) {
            startStopTimes = ShiftsMethods.getperiodDayStartStopTimesByDate(
              dates[i],
              ShiftsMethods.getperiodByDate(
                dates[i],
                this.dataShiftPeriods,
                this.routes[routeIndex]["id"]
              )
            );
          }
          let routeNumber = parseInt(routeIndex) + 1;
          events.push({
            title:
              dayRouteStatus === 1 && dayShiftStatus === 1
                ? "(" +
                  routeNumber +
                  ") " +
                  (this.routes[routeIndex] !== undefined
                    ? this.routes[routeIndex].name
                    : "")
                : dayRouteStatus === 0 && dayShiftStatus === 0
                ? "(" +
                  routeNumber +
                  ") " +
                  (this.routes[routeIndex] !== undefined
                    ? this.routes[routeIndex].name + ": "
                    : "") +
                  "Route & dienst inactief"
                : dayRouteStatus === 1 && dayShiftStatus === 0
                ? "(" +
                  routeNumber +
                  ") " +
                  (this.routes[routeIndex] !== undefined
                    ? this.routes[routeIndex].name + ": "
                    : "") +
                  "Dienst inactief"
                : "(" +
                  routeNumber +
                  ") " +
                  (this.routes[routeIndex] !== undefined
                    ? this.routes[routeIndex].name + " "
                    : "") +
                  "Route inactief",
            start:
              dayRouteStatus === 1 && dayShiftStatus === 1
                ? new Date(dates[i] + " " + startStopTimes[0])
                : new Date(dates[i] + " 00:00:00"),
            end:
              dayRouteStatus === 1 && dayShiftStatus === 1
                ? new Date(dates[i] + " " + startStopTimes[1])
                : new Date(dates[i] + " 00:00:00"),
            className:
              dayRouteStatus === 1 && dayShiftStatus === 1
                ? "event-green"
                : "event-red",
            backgroundColor:
              dayRouteStatus === 1 && dayShiftStatus === 1 ? "green" : "red",
            allDay: false
          });
        }
      }

      return events;
    },
    showEvents: function() {
      if (
        this.routes.length > 0 &&
        this.routesPeriods.length > 0 &&
        this.selectedRoutes.length > 0
      ) {
        return true;
      }

      return false;
    }
  },
  methods: {
    init() {
      this.loadRoutes(this.$route.params.id);
      this.loadShift();
      this.loadShiftPeriods();
      this.loadHolidays();
    },
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    goBack() {
      this.$router.push("/shifts/overview/");
    },
    shiftId() {
      return this.$route.params.id;
    },
    loadShift() {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "shifts/" + this.$route.params.id).then(
        response => {
          this.shift = response.data.shift;

          this.requesting = false;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van shifts", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadShiftPeriods() {
      this.requesting = true;
      this.$http
        .get(this.$apiBaseUrl + "shifts/" + this.$route.params.id + "/periods")
        .then(
          response => {
            this.shiftPeriods = ShiftsMethods.reformatLoadedShiftPeriods(
              response.data.shiftPeriods
            );
            this.requesting = false;
          },
          response => {
            this.requesting = false;
            if (response.status === 403) {
              // this.notifyVue("U heeft geen rechten voor het beheren van shifts", 'add_alert', 'danger', 0);
            }
          }
        );
    },
    loadShiftRoutes(id, routes) {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "shifts/" + id + "/routes").then(
        response => {
          for (var i in routes) {
            for (var j in response.data.routes) {
              if (routes[i].id != response.data.routes[j].id) {
                continue;
              }
              routes[i].shiftName = response.data.routes[j].pivot.name;
              this.selectedRoutes[i] = true;
            }
          }

          this.routes = routes;
          this.loadRoutesPeriods();

          this.requesting = false;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van diensten", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadRoutes(id) {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "routes").then(
        response => {
          this.selectedRoutes = [];
          for (var i in response.data.routes) {
            this.selectedRoutes[i] = false;
            response.data.routes[i].shiftName = this.name;
          }

          this.loadShiftRoutes(id, response.data.routes);

          // this.requesting = false;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van diensten", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadRoutesPeriods() {
      this.requesting = true;

      let routesPeriods = [];

      let routesPeriodsLoaded = 0;

      for (let i in this.routes) {
        this.$http
          .get(this.$apiBaseUrl + "routes/" + this.routes[i].id + "/periods")
          .then(
            response => {
              routesPeriodsLoaded++;
              routesPeriods[i] = RoutesMethods.reformatLoadedRoutePeriods(
                response.data.routePeriods
              );
              this.requesting = false;

              if (this.routes.length === routesPeriods.length) {
                this.routesPeriods = routesPeriods;
              }
            },
            response => {
              routesPeriodsLoaded++;
              this.requesting = false;
              if (response.status === 403) {
                // this.notifyVue("U heeft geen rechten voor het beheren van routes", 'add_alert', 'danger', 0);
              }
            }
          );
      }
    },
    loadHolidays() {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "holidays").then(
        response => {
          this.holidays = response.data.nationalHolidays;
          this.requesting = false;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            this.generateDisabled = false;
            this.notifyVue(
              "U heeft geen rechten voor het beheren van feestdagen",
              "add_alert",
              "danger",
              0
            );
          }
        }
      );
    },
    isDateHoliday(date) {
      for (let i in this.holidays) {
        if (this.holidays[i].date === date) {
          return true;
        }
      }

      return false;
    },
    getHolidayNameByDate(date) {
      for (let i in this.holidays) {
        if (this.holidays[i].date === date) {
          return this.holidays[i].name;
        }
      }

      return "";
    },
    handleAddPeriod(id) {
      this.$router.push("/shifts/periods/" + id + "/add/");
    },
    dateClick: function(info) {
      // // on select we show the Sweet Alert modal with an input
      // Swal.fire({
      //   title: "Create an Event",
      //   html: `<div class="md-field md-theme-default">
      //     <input type="text" id="md-input" class="md-input">
      //     </div>`,
      //   showCancelButton: true,
      //   confirmButtonClass: "md-button md-success",
      //   cancelButtonClass: "md-button md-danger",
      //   buttonsStyling: false
      // }).then(() => {
      //   var eventTitle = document.getElementById("md-input").value;
      //   if (eventTitle) {
      //     let calendarApi = this.$refs.calendar.getApi();
      //     calendarApi.addEvent({
      //       title: eventTitle,
      //       start: info.dateStr,
      //       allDay: true
      //     });
      //   }
      // });
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  }
};
</script>
<style lang="scss">
.md-card {
  .md-card-actions {
    border: none;
  }
  .md-card-content {
    padding: 10px !important;
    line-height: 1.25em !important;
  }
}

.md-layout {
  .md-layout-item {
    padding-right: 5px;
    padding-left: 5px;
  }
}

#fullCalendar {
  min-height: 300px;
}

.md-card-calendar {
  .md-card-content {
    padding: 0 !important;
  }
}

.text-center {
  text-align: center;
}

.md-datepicker-days {
  .md-datepicker-day-button {
    height: 25px;
    line-height: 25px;
  }
}
.md-datepicker-day-button {
  font-size: 0.75rem;
}
</style>
